import React from 'react';

/**
 * ConversionSocialProof
 *
 * Props:
 * - testimonials: array of testimonial objects
 * - currentTestimonial: index of the currently visible testimonial
 * - setCurrentTestimonial: setter to change the active testimonial
 */
const ConversionSocialProof = ({
  testimonials,
  currentTestimonial,
  setCurrentTestimonial
}) => {
  if (!testimonials || testimonials.length === 0) return null;

  const active = testimonials[currentTestimonial];

  return (
    <div className="bg-white rounded-xl shadow-lg p-8 mb-8">
      <div className="text-center mb-8">
        <h3 className="text-2xl font-bold text-gray-900 mb-2">
          Join 2,500+ Companies Saving Millions
        </h3>
        <p className="text-gray-600">
          See what energy managers are saying about RAMP professional reports
        </p>
      </div>

      <div className="bg-gray-50 rounded-xl p-6 relative">
        <div className="text-center">
          <svg
            className="w-8 h-8 text-emerald-500 mx-auto mb-4"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.863c-2.896.909-4.695 2.723-4.695 5.746v2.391h4.695v7h-9.978zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.863c-2.913.909-4.996 2.723-4.996 5.746v2.391h4.996v7h-9.996z" />
          </svg>
          <blockquote className="text-lg text-gray-700 mb-4 italic">
            "{active.quote}"
          </blockquote>
          <div className="font-medium text-gray-900">{active.author}</div>
          <div className="text-gray-600">{active.company}</div>
          <div className="text-emerald-600 font-bold mt-2">
            Annual Savings: {active.savings}
          </div>
        </div>
      </div>

      <div className="flex justify-center space-x-2 mt-4">
        {testimonials.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentTestimonial(index)}
            className={`w-3 h-3 rounded-full transition-colors ${
              index === currentTestimonial ? 'bg-emerald-500' : 'bg-gray-300'
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default ConversionSocialProof;


